import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header"></header>
      <body>My name is Uzair</body>
    </div>
  );
}

export default App;
